<div *ngIf="displayMyInvoicesImage" class="hero">
  <div class="hero-overlay"></div>
  <div class="hero-content d-flex">
    <div class="container d-flex flex-row">
      <div class="hero-content-text align-self-center">
        <h1>
          <span class="fw-light">My invoices</span><br>
        </h1>
      </div>
    </div>
  </div>
</div>

<div class="container mt-4 mb-5">

  <ngb-alert *ngIf="filterInvoicesByStatus(invoiceStatus.Open).length" [dismissible]="false">You have outstanding invoices.</ngb-alert>

  <div class="row mt-5">
    <div class="col-12">
      <div *ngFor="let invoice of filterInvoicesByStatus(invoiceStatus.Open)" dismissable="false" class="row mb-3">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-lg-2 my-auto">
                  Status: <strong class="text-danger">Unpaid</strong>
                </div>
                <div class="col-lg-3 my-auto">
                  <div><small>Created at: {{ invoice.created | date: 'dd/MM/yyyy - HH:mm' }}</small></div>
                  <div><small>Updated at: {{ invoice.updated | date: 'dd/MM/yyyy - HH:mm' }}</small></div>
                </div>
                <div class="col-lg-3 my-auto">
                  <small>Description:
                    <strong>
                      <app-read-more
                        [content]="invoice.description"
                        [limit]="60">
                      </app-read-more>
                    </strong>
                  </small>
                </div>
                <div class="col-lg-2 my-auto">
                  <h5 class="my-3 my-lg-0">{{ invoice.totalAmount / 100 | currency:invoice.currency }}</h5>
                </div>
                <div class="col-lg-2 my-auto invoice-button-wrapper">
                  <button type="button" class="btn btn-primary w-100 invoice-button" (click)="view(invoice)">
                    Pay now
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <span *ngFor="let invoice of filterInvoicesByStatus(invoiceStatus.Paid); let paidInvoiceIndex = index">
        <div *ngIf="!maxNrOfDisplayedPaidInvoices || (maxNrOfDisplayedPaidInvoices && paidInvoiceIndex < maxNrOfDisplayedPaidInvoices)"
         dismissable="false" class="row mb-3">
          <div class="col-12">
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-2 my-auto">
                    Status: <strong class="text-success">Paid</strong>
                  </div>
                  <div class="col-lg-3 my-auto">
                    <div><small>Created at: {{ invoice.created | date: 'dd/MM/yyyy - HH:mm' }}</small></div>
                    <div><small>Paid at: {{ invoice.updated | date: 'dd/MM/yyyy - HH:mm' }}</small></div>
                  </div>
                  <div class="col-lg-3 my-auto">
                    <small>Description:
                      <strong>
                        <app-read-more
                          [content]="invoice.description"
                          [limit]="60">
                        </app-read-more>
                      </strong>
                    </small>
                  </div>
                  <div class="col-lg-2 my-auto">
                    <h5 class="my-3 my-lg-0">{{ invoice.totalAmount / 100 | currency:invoice.currency }}</h5>
                  </div>
                  <div class="col-lg-2 my-auto invoice-button-wrapper">
                    <button type="button" class="btn btn-light w-100 invoice-button" (click)="view(invoice)">
                      View
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </span>

      <div *ngIf="maxNrOfDisplayedPaidInvoices && nrOfPaidInvoices > maxNrOfDisplayedPaidInvoices">
        <a [routerLink]="['/account/invoices']">
          Check the full list of invoices
        </a>
      </div>

      <div *ngIf="(invoices && !invoices.length)">
        You do not have any outstanding invoices.
      </div>
      <div *ngIf="showInvoicesAreBeingProcessedText()">
        Your invoices are being processed
      </div>

      <div *ngIf="!invoices" class="loading-spinner-wrapper">
        <fa-icon [icon]="['fas', 'spinner']" [animation]="'spin'" size="5x"></fa-icon>
      </div>

    </div>
  </div>

</div>
